<template>
  <div>
    <div class="md-collapse">
      <div class="md-collapse-label" @click="visible = !visible">
        <h5 class="md-collapse-title regular text-primary">
          <img
            v-if="panelIcon"
            :src="panelIcon"
            style="width:30px; margin-right:5px;margin-left:5px"
          />
          {{ name }}
        </h5>
      </div>

      <collapse-transition :duration="350">
        <div v-show="visible" class="md-collapse-content">
          <div v-for="item in items" :key="item.gid">
            <panel-item v-if="item.itemType == 0" :item="item" :showDetailsLink="true"></panel-item>
            <cultural-event-item
              v-if="item.itemType == 1 "
              :item="item"
              @showDetails="onShowCulturalEventDetails(item)"
            ></cultural-event-item>
          </div>
          <!-- <item v-for="item in items" :item="item" :key="item.id" showDetailsLink="true" /> -->
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import axios from "@/util/axios";
import { CollapseTransition } from "vue2-transitions";
import { mapGetters } from "vuex";
import PanelItem from "./PanelListItem";
import CulturalEventItem from "./CulturalEventListItem";

export default {
  name: "Collapse",
  components: {
    CollapseTransition,
    PanelItem,
    CulturalEventItem
  },
  props: ["name", "items"],
  data() {
    return { visible: false };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings"
    }),

    // panelColor() {
    //   return this.$options.filters["panel-color"](this.name);
    // },
    panelIcon() {
      return this.$options.filters["panel-icon"](this.name);
    }
  },
  methods: {
    async onShowCulturalEventDetails(item) {
      let result = (
        await axios.get(
          "public/conferences/conference/cultural-events/details",
          {
            params: {
              id: item.id,
              language: this.language.code
            }
          }
        )
      ).data;

      var selectedItemResult = { topic: item.description.topic, html: result };
      this.$emit("selectedItem", selectedItemResult);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  display: flex;
}

.md-collapse-content {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
